import { render, staticRenderFns } from "./DeliveryForm.vue?vue&type=template&id=f6e9d53a&scoped=true&"
import script from "./DeliveryForm.vue?vue&type=script&lang=ts&"
export * from "./DeliveryForm.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryForm.vue?vue&type=style&index=0&id=f6e9d53a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e9d53a",
  null
  
)

export default component.exports